import { EdgePatientEnrollmentApi } from '@trialcard/apigateway.client/edgePatientEnrollmentApi';
import {
    EnrollPatientRequestModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel,
    EnterpriseCoordinatorAccountUpsearchRequestModel,
    EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    EnterpriseCoordinatorSharedAddressUpsearchModel,
    EnterpriseCoordinatorSharedEmailAddressUpsearchModel,
    EnterpriseCoordinatorSharedPhoneUpsearchModel,
    UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel,
} from '@trialcard/apigateway.models';
import { Gender, RoleType } from '@trialcard/enums';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Action, Mutation } from 'vuex-module-decorators';
 
import { EdgeEnrollmentApi } from '@trialcard/apigateway.client';
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import { PDFDocument } from 'pdf-lib';
import { EdgeDocumentsApi } from '@trialcard/apigateway.client/edgeDocumentsApi';
import { string } from 'yargs';
import { Settings } from '~/services/settings';
import SurveyModule from '~/store/survey';
import sectionStore from '~/store/section';
import genders from '~/assets/genders';
import PharmacyEligibilityModule from '~/store/pharmacy-eligibility';
import EligibilityModule from '~/store/eligibility';
 
@InjectModule({ stateFactory: true }, module)
export default class EnrollmentModule extends InjectVuexModule {
    @Resolve
    public patientEnrollmentApi!: EdgePatientEnrollmentApi;
 
    @Resolve
    public enrollmentApi!: EdgeEnrollmentApi;
 
    @Resolve
    public settings!: Settings;
 
    @Resolve
    public survey!: SurveyModule;
 
    @Resolve
    edgeDocumentsApi!: EdgeDocumentsApi;

    @Resolve
    sectionStore!: sectionStore;
 
    @Resolve
    public hcpPharmacyeligibility!: PharmacyEligibilityModule;
 
    @Resolve
    public patientEligibility!: EligibilityModule;
 
    defaultPatientInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        dateOfBirth: null as Moment | null,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        emailAddresses: [] as EnterpriseCoordinatorSharedEmailAddressUpsearchModel[],
        phoneNumbers: [] as EnterpriseCoordinatorSharedPhoneUpsearchModel[],
        gender: null as Gender | null,
        relationShipToPatient: '' as string,
        caregiverFirstName: '' as string,
        trainingType: '' as string,
    };
 
    defaultCareGiverInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        emailAddresses: [] as EnterpriseCoordinatorSharedEmailAddressUpsearchModel[],
        phoneNumbers: [] as EnterpriseCoordinatorSharedPhoneUpsearchModel[],
        relationShipToPatient: '' as string,
    };
 
    defaultPrescriberData = [
        {
            model: {
                firstName: '',
                lastName: '',
                npi: '',
                accountRelationshipIsPrimary: true,
                prescriberLicenses: [],
                externalIds: [],
                addresses: [],
                phoneNumbers: [],
                emailAddresses: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[];
 
    defaultSiteData = [
        {
            model: {
                accountRelationshipIsPrimary: true,
                siteRoleType: RoleType.PrescriberSite,
                pointOfContacts: [],
                description: '',
                addresses: [
                    {
                        addressOne: '',
                        addressTwo: '',
                        zip: '',
                        city: '',
                        state: '',
                    },
                ],
                contacts: [],
                emailAddresses: [],
                externalIds: [],
                phoneNumbers: [],
                globalIds: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[];
 
    defaultPayorObject = [
        {
            model: {
                payorId: (null as unknown) as number,
                payorType: (null as unknown) as number,
                accountRelationshipIsPrimary: true,
                payorGroup: '',
                payorName: '',
                webAddresses: [],
                addresses: [],
                phoneNumbers: [
                    {
                        phoneType: 1,
                        phoneNumber: '',
                        phonePurpose: 1,
                    },
                    {
                        phoneType: 3,
                        phoneNumber: '',
                        phonePurpose: 8,
                    },
                ],
                emailAddresses: [],
                contacts: [],
                payorBenefit: {
                    dateOfBirth: null as Moment | null,
                    policyHolderFirstName: '',
                    policyHolderLastName: '',
                    relationshipToPatient: undefined,
                    policyNumber: '',
                    planType: undefined,
                },
            },
        },
    ];
 
    defaultPayorData = [] as UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel[];
    // defaultNcpdp = '';
 
    defaultContactPreferences = [] as EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[];
    defaultContacts = [] as EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel[];
 
    defaultMemberNumbers = {
        medical: 'XXXXXXXXXXX',
        pharmacy: 'XXXXXXXXXXX',
    };
    defaultMemberNumber = 'XXXXXXXXXXX';
    defaultExpirationDate = moment().utc();
    pharmaMemberNumber = this.defaultMemberNumbers.pharmacy;
    medicalMemberNumber = this.defaultMemberNumbers.medical;
 
    public defaultAuthorizationData = {
        // consentCheckbox: false as boolean,
        tncCheckbox: false as boolean,
        // fcraCheckbox: false as boolean,
        // tcpaConsentCheckbox: false as boolean,
        signature: '',
        // LName: '',
        // repLName: '',
        // repFName: '',
        // patientHomePhone: '',
        // relationShipToPatient: '',
    };
 
    public defaultPrescriberInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        siteName: '' as string,
        officeContactName: '' as string,
        addressLineOne: '' as string,
        addressLineTwo: '' as string,
        zipCode: '' as string,
        city: '' as string,
        state: '' as string,
        officeContactPrimaryPhone: '' as string,
        officePrimaryFax: '' as string,
    };
 
    public defaultHealthInsuranceFormData = {
        hasMedicalInsurance: false as boolean,
        hasPharmacyInsurance: false as boolean,
        medicalInsuranceState: '' as string,
        medicalInsuranceCarrier: '' as string,
        medicalPolicyHolderFirstName: '' as string,
        medicalPolicyHolderLastName: '' as string,
        policyNumber: '' as string,
        groupNumber: '' as string,
        pharmacyInsuranceState: '' as string,
        pharmacyInsuranceCarrier: '' as string,
        pharmacyPolicyHolderFirstName: '' as string,
        pharmacyPolicyHolderLastName: '' as string,
        rxGroup: '' as string,
        rxId: '' as string,
        rxBin: '' as string,
        rxPcn: '' as string,
    };
 
    defaultInsuranceCheckboxData = {
        pharmacy : false as boolean,
        medical : false as boolean
    }
 
 
    memberNumber = this.defaultMemberNumber;
    expirationDate = this.defaultExpirationDate;
    patientInformationData = { ...this.defaultPatientInformationData };
    careGiverInformationData = { ...this.defaultCareGiverInformationData };
    prescriberData = [...this.defaultPrescriberData];
    siteData = [...this.defaultSiteData];
    payorData = [...this.defaultPayorData];
    contactPreferences = [...this.defaultContactPreferences];
    AuthorizationData = { ...this.defaultAuthorizationData };
    isCareGiver = false as boolean;
    contacts = [...this.defaultContacts] as EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel[];
    ncpdp = '';
    pharmacySignature = '' as string;
    prescriberSignature = '' as string;
    trainingType = '' as string;
    prescriberInformationData = { ...this.defaultPrescriberInformationData };
    healthInsuranceFormData = { ...this.defaultHealthInsuranceFormData };
    savedCheckBoxState = {...this.defaultInsuranceCheckboxData};
 
    @Mutation
    public async updateInsuranceCheckbox(value: any){
        this.savedCheckBoxState = {...value};
    }
   
    @Mutation
    public setPharmaMemberNumber(pharmaMemberNumber: string) {
        this.pharmaMemberNumber = pharmaMemberNumber;
    }
 
    @Mutation
    public setMedicalMemberNumber(medicalMemberNumber: string) {
        this.medicalMemberNumber = medicalMemberNumber;
    }
 
    @Mutation
    updateAuthorizationData(newAuthorizationData: typeof EnrollmentModule.prototype.defaultAuthorizationData) {
        this.AuthorizationData = { ...newAuthorizationData };
    }
 
    @Mutation
    public async updateContacts(newContacts: EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel[]) {
        this.contacts = newContacts;
    }
 
    @Mutation
    public async updatePatientInformation(newPatientInformation: typeof EnrollmentModule.prototype.patientInformationData) {
        this.patientInformationData = { ...this.patientInformationData, ...newPatientInformation };
    }
 
    @Mutation
    public async updatePrescribers(newPrescriberData: UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[]) {
        this.prescriberData = [...newPrescriberData];
    }
 
    @Mutation
    public async updateSites(newSites: UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[]) {
        this.siteData = [...newSites];
    }
 
    @Mutation
    public async updatePayors(newPayorData: UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel[]) {
        this.payorData = [...newPayorData];
    }
 
    @Mutation
    public async updateCareGiverInformation(newCareGiverInformation: typeof EnrollmentModule.prototype.careGiverInformationData) {
        this.careGiverInformationData = { ...this.careGiverInformationData, ...newCareGiverInformation };
    }
 
    @Mutation
    public async updateContactPreferences(newContactPreferences: EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[]) {
        this.contactPreferences = [...newContactPreferences];
    }
 
    @Mutation
    public setMemberNumber(memberNumber: string) {
        this.memberNumber = memberNumber;
    }
 
    @Mutation
    public setNcpdp(ncpdp: string) {
        this.ncpdp = ncpdp;
    }
 
    @Mutation
    public setPharmacySignature(pharmacySignature: string) {
        this.pharmacySignature = pharmacySignature;
    }
 
    @Mutation
    public setPrescriberSignature(prescriberSignature: string) {
        this.prescriberSignature = prescriberSignature;
    }
 
    @Mutation
    public setExpirationDate(expirationDate: Moment) {
        this.expirationDate = expirationDate;
    }
 
    @Mutation
    public setIsCareGiver(isCareGiver: boolean) {
        this.isCareGiver = isCareGiver;
    }
 
    @Mutation
    public setTrainingType(trainingType: string) {
        this.patientInformationData.trainingType = trainingType;
    }
 
    @Mutation
    public setPrescriberInformationData(newPrescriberInformationData: typeof EnrollmentModule.prototype.prescriberInformationData) {
        this.prescriberInformationData = newPrescriberInformationData;
    }
 
    @Mutation
    public setHealthInsuranceFormData(newHealthInsuranceFormData: typeof EnrollmentModule.prototype.defaultHealthInsuranceFormData) {
        this.healthInsuranceFormData = { ...newHealthInsuranceFormData };
    }
 
    @Action({ rawError: true })
    public clearStore() {
        this.setMemberNumber(this.defaultMemberNumber);
        this.setPharmaMemberNumber(this.defaultMemberNumbers.pharmacy);
        this.setMedicalMemberNumber(this.defaultMemberNumbers.medical);
        this.setExpirationDate(this.defaultExpirationDate);
        this.updatePatientInformation(this.defaultPatientInformationData);
        this.updateCareGiverInformation(this.defaultCareGiverInformationData);
        this.updatePrescribers(this.defaultPrescriberData);
        this.updateSites(this.defaultSiteData);
        this.updatePayors(this.defaultPayorData);
        this.updateContactPreferences(this.defaultContactPreferences);
        this.updateAuthorizationData(this.defaultAuthorizationData);
        this.setIsCareGiver(false);
        this.hcpPharmacyeligibility.clearStore();
        this.patientEligibility.clearStore();
        this.setNcpdp('');
        this.updateContacts(this.defaultContacts);
        this.setPharmacySignature('');
        this.setPrescriberSignature('');
        this.setTrainingType('');
        this.setPrescriberInformationData(this.defaultPrescriberInformationData);
        this.setHealthInsuranceFormData(this.defaultHealthInsuranceFormData);
        this.updateInsuranceCheckbox(this.defaultInsuranceCheckboxData);
    }
 
    @Action({ rawError: true })
    public clearEnrollment() {
        this.updatePatientInformation({ ...this.defaultPatientInformationData });
        this.setMemberNumber(this.defaultMemberNumber);
        this.setPharmaMemberNumber(this.defaultMemberNumbers.pharmacy);
        this.setMedicalMemberNumber(this.defaultMemberNumbers.medical);
        this.updateAuthorizationData(this.defaultAuthorizationData);
        this.setNcpdp('');
        this.setPharmacySignature('');
        this.setPrescriberSignature('');
    }
 
    @Action({ rawError: true })
    public async submitToAPI() {
        let response = null;
        const { prescriberData, siteData, payorData, contactPreferences } = this;
         let patient;
        try {
             if (this.sectionStore.activeUniqueMenuItems.navTitle === 'Enroll in Co-Pay Assistance Only') {
             patient = {
                account: {
                    patientData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            ...this.patientInformationData,
                            middleName: '',
                            suffix: '',
                            nickname: '',
                        } as EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    } as UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    accountData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            accountType: 1,
                            accountStatus: 1,
                            contactPreferences,
                            contacts: this.contacts,
                        },
                    } as UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
                    surveySessionData: [this.survey.sessionId] as number[],
                } as EnterpriseCoordinatorAccountUpsearchRequestModel,
            } as EnrollPatientRequestModel;
        } else {
                patient = {
                account: {
                    patientData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            ...this.patientInformationData,
                            middleName: '',
                            suffix: '',
                            nickname: '',
                        } as EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    } as UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    accountData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            accountType: 1,
                            accountStatus: 1,
                            contactPreferences,
                            contacts: this.contacts,
                        },
                    } as UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
                    surveySessionData: [this.survey.sessionId] as number[],
                } as EnterpriseCoordinatorAccountUpsearchRequestModel,
            } as EnrollPatientRequestModel;
        }
 
            const axios: AxiosInstance = (this.patientEnrollmentApi as any).axios;
            const axiosRequest: AxiosRequestConfig = {
                url: '/edge/patientEnrollment/enrollPatient',
                method: 'POST',
                data: patient,
                headers: {
                    'x-program-id': this.settings.programId!,
                },
            };
            await Promise.all([
                (this.patientEnrollmentApi as any).authentications.ApiKey.applyToRequest(axiosRequest),
                (this.patientEnrollmentApi as any).authentications.Bearer.applyToRequest(axiosRequest),
                (this.patientEnrollmentApi as any).authentications.Token.applyToRequest(axiosRequest),
            ]);
            response = await axios.request(axiosRequest);
        } catch {
            response = { status: 400 } as AxiosResponse;
        }
        return response;
    }
 
    async writePdf() {
        if (this.isCareGiver) {
            const pdfArrayRes = await fetch(this.settings.url('/patient-authorization-for-juvenile.pdf'));
            const formBytes = await pdfArrayRes.arrayBuffer();
            const baseDoc = await PDFDocument.load(formBytes);
            const form = baseDoc.getForm();
            const gender = genders.find(gender => gender.id === this.patientInformationData.gender);
            const address = this.patientInformationData.addresses.length > 0 ? this.patientInformationData.addresses[0] : {};
            const parentMobilePhone =
                this.careGiverInformationData.phoneNumbers.length > 0 ? this.careGiverInformationData.phoneNumbers[0] : {};
            const parentHomePhone =
                this.careGiverInformationData.phoneNumbers.length > 0 ? this.careGiverInformationData.phoneNumbers[1] : {};
            const parentEmail =
                this.careGiverInformationData.emailAddresses.length > 0 ? this.careGiverInformationData.emailAddresses[0] : {};
            const dateOfBirth = this.patientInformationData.dateOfBirth
                ? moment.utc(this.patientInformationData.dateOfBirth || '', ['MM/DD/YYYY', 'YYYY-MM-DD'])
                : moment();
            form.getTextField('patientFirstName').setText(this.patientInformationData.firstName);
            form.getTextField('patientFirstName').enableReadOnly();
            form.getTextField('patientLastName').setText(this.patientInformationData.lastName);
            form.getTextField('patientLastName').enableReadOnly();
            form.getTextField('patientGender').setText((gender && gender.name) || '');
            form.getTextField('patientGender').enableReadOnly();
            form.getTextField('patientDateOfBirth').setText(dateOfBirth.format('L'));
            form.getTextField('patientDateOfBirth').enableReadOnly();
            form.getTextField('patientAddressLine1').setText(address.addressOne);
            form.getTextField('patientAddressLine1').enableReadOnly();
            form.getTextField('patientAddressLine2').setText(address.addressTwo || '');
            form.getTextField('patientAddressLine2').enableReadOnly();
            form.getTextField('patientZipCode').setText(address.zip);
            form.getTextField('patientZipCode').enableReadOnly();
            form.getTextField('patientCity').setText(address.city);
            form.getTextField('patientCity').enableReadOnly();
            form.getTextField('patientState').setText(address.state);
            form.getTextField('patientState').enableReadOnly();
            form.getTextField('patientParentOrGuardianName').setText(this.careGiverInformationData.firstName);
            form.getTextField('patientParentOrGuardianName').enableReadOnly();
            form.getTextField('patientParentOrGuardianRelationshipToPatient').setText(this.careGiverInformationData.relationShipToPatient);
            form.getTextField('patientParentOrGuardianRelationshipToPatient').enableReadOnly();
            form.getTextField('patientParentOrGuardianMobilePhone').setText(parentMobilePhone.phoneNumber);
            form.getTextField('patientParentOrGuardianMobilePhone').enableReadOnly();
            form.getTextField('patientParentOrGuardianHomePhone').setText(parentHomePhone?.phoneNumber || '');
            form.getTextField('patientParentOrGuardianHomePhone').enableReadOnly();
            form.getTextField('patientParentOrGuardianEmail').setText(parentEmail.address || '');
            form.getTextField('patientParentOrGuardianEmail').enableReadOnly();
            // if (this.AuthorizationData.consentCheckbox) {
            //     form.getCheckBox('patientAuthorizationCheckbox1').check();
            //     form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            // } else {
            //     form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            // }
            if (this.AuthorizationData.tncCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox2').check();
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            }
            // if (this.AuthorizationData.tcpaConsentCheckbox) {
            //     form.getCheckBox('patientAuthorizationCheckbox3').check();
            //     form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            // } else {
            //     form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            // }
            // if (this.AuthorizationData.fcraCheckbox) {
            //     form.getCheckBox('patientAuthorizationCheckbox4').check();
            //     form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            // } else {
            //     form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            // }
            // form.getTextField('patientAuthorizationFirstName').setText(this.AuthorizationData.FName);
            // form.getTextField('patientAuthorizationFirstName').enableReadOnly();
            // form.getTextField('patientAuthorizationLastName').setText(this.AuthorizationData.LName);
            form.getTextField('patientAuthorizationLastName').enableReadOnly();
            form.getTextField('patientAuthorizationTodayDate').setText(moment().format('L'));
            form.getTextField('patientAuthorizationTodayDate').enableReadOnly();
 
            const exportBytes = await baseDoc.save();
            return exportBytes;
        } else {
            const pdfArrayRes = await fetch(this.settings.url('/patient-authorization-for-non-juvenile.pdf'));
            const formBytes = await pdfArrayRes.arrayBuffer();
            const baseDoc = await PDFDocument.load(formBytes);
            const form = baseDoc.getForm();
            const gender = genders.find(gender => gender.id === this.patientInformationData.gender);
            const address = this.patientInformationData.addresses.length > 0 ? this.patientInformationData.addresses[0] : {};
            const patientMobilePhone =
                this.patientInformationData.phoneNumbers.length > 0 ? this.patientInformationData.phoneNumbers[0] : {};
            const patientHomePhone = this.patientInformationData.phoneNumbers.length > 0 ? this.patientInformationData.phoneNumbers[1] : {};
            const parentEmail = this.patientInformationData.emailAddresses.length > 0 ? this.patientInformationData.emailAddresses[0] : {};
            const dateOfBirth = this.patientInformationData.dateOfBirth
                ? moment.utc(this.patientInformationData.dateOfBirth || '', ['MM/DD/YYYY', 'YYYY-MM-DD'])
                : moment().utc();
            form.getTextField('patientFirstName').setText(this.patientInformationData.firstName);
            form.getTextField('patientFirstName').enableReadOnly();
            form.getTextField('patientLastName').setText(this.patientInformationData.lastName);
            form.getTextField('patientLastName').enableReadOnly();
            form.getTextField('patientGender').setText((gender && gender.name) || '');
            form.getTextField('patientGender').enableReadOnly();
            form.getTextField('patientDateOfBirth').setText(dateOfBirth.format('L'));
            form.getTextField('patientDateOfBirth').enableReadOnly();
            form.getTextField('patientAddressLine1').setText(address.addressOne);
            form.getTextField('patientAddressLine1').enableReadOnly();
            form.getTextField('patientAddressLine2').setText(address.addressTwo || '');
            form.getTextField('patientAddressLine2').enableReadOnly();
            form.getTextField('patientZipCode').setText(address.zip);
            form.getTextField('patientZipCode').enableReadOnly();
            form.getTextField('patientCity').setText(address.city);
            form.getTextField('patientCity').enableReadOnly();
            form.getTextField('patientState').setText(address.state);
            form.getTextField('patientState').enableReadOnly();
            form.getTextField('patientMobilePhone').setText(patientMobilePhone.phoneNumber);
            form.getTextField('patientMobilePhone').enableReadOnly();
            form.getTextField('patientHomePhone').setText(patientHomePhone?.phoneNumber || '');
            form.getTextField('patientHomePhone').enableReadOnly();
            form.getTextField('patientEmailAddress').setText(parentEmail.address || '');
            form.getTextField('patientEmailAddress').enableReadOnly();
            // if (this.AuthorizationData.consentCheckbox) {
            //     form.getCheckBox('patientAuthorizationCheckbox1').check();
            //     form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            // } else {
            //     form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            // }
            if (this.AuthorizationData.tncCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox2').check();
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            }
            // if (this.AuthorizationData.tcpaConsentCheckbox) {
            //     form.getCheckBox('patientAuthorizationCheckbox3').check();
            //     form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            // } else {
            //     form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            // }
            // if (this.AuthorizationData.fcraCheckbox) {
            //     form.getCheckBox('patientAuthorizationCheckbox4').check();
            //     form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            // } else {
            //     form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            // }
            // form.getTextField('patientAuthorizationFirstName').setText(this.AuthorizationData.FName);
            // form.getTextField('patientAuthorizationFirstName').enableReadOnly();
            // form.getTextField('patientAuthorizationLastName').setText(this.AuthorizationData.LName);
            form.getTextField('patientAuthorizationLastName').enableReadOnly();
            form.getTextField('patientAuthorizationTodayDate').setText(
                moment()
                    .utc()
                    .format('L')
            );
            form.getTextField('patientAuthorizationTodayDate').enableReadOnly();
 
            const exportBytes = await baseDoc.save();
            return exportBytes;
        }
    }
    public async uploadPdf(blob: Blob) {
        const formData = new FormData();
        formData.append('type', '10001');
        formData.append('attachment', blob);
 
        formData.append('externalPartyCode', 'CLS');
        formData.append('externalProgramCode', 'HYRI');
        const axios: AxiosInstance = (this.edgeDocumentsApi as any).axios;
        const axiosRequest: AxiosRequestConfig = {
            url: 'edge/documents/v1/Document/upload',
            method: 'POST',
            data: formData,
            headers: {
                'x-program-id': this.settings.clsProgramId!,
            },
        };
 
        await Promise.all([
            // (this.edgeDocumentsApi as any).authentications.ApiKey.applyToRequest(axiosRequest),
            // (this.edgeDocumentsApi as any).authentications.Bearer.applyToRequest(axiosRequest),
            (this.edgeDocumentsApi as any).authentications.Token.applyToRequest(axiosRequest),
        ]);
 
        const result = await axios.request(axiosRequest);
        return result;
    }
}